import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderSlot as _renderSlot, unref as _unref } from "vue"

import { ref } from 'vue'
import { ElForm } from 'element-plus'
import type { CrudFormItem } from '@/types/crud-config'

type FormRef = InstanceType<typeof ElForm>


export default /*#__PURE__*/_defineComponent({
  __name: 'CrudForm',
  props: {
    model: {},
    items: {},
    rules: { default: () => ({}) },
    labelWidth: { default: '100px' }
  },
  setup(__props: any, { expose: __expose }) {

const props = __props

const formRef = ref<FormRef>()

const validate = () =>
  new Promise<boolean>((resolve) => formRef.value!.validate(resolve))

const isDisabled = (item: CrudFormItem) =>
  typeof item.disabled === 'function'
    ? item.disabled(props.model)
    : item.disabled

__expose({ validate })

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!

  return (_openBlock(), _createBlock(_unref(ElForm), {
    ref_key: "formRef",
    ref: formRef,
    class: "crud-form",
    model: _ctx.model,
    rules: _ctx.rules,
    "label-width": _ctx.labelWidth
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
        return (_openBlock(), _createBlock(_component_el_form_item, {
          key: item.prop,
          label: item.label,
          prop: item.prop
        }, {
          default: _withCtx(() => [
            (item.type === 'input')
              ? (_openBlock(), _createBlock(_component_el_input, {
                  key: 0,
                  modelValue: _ctx.model[item.prop],
                  "onUpdate:modelValue": ($event: any) => ((_ctx.model[item.prop]) = $event),
                  class: "crud-form__control",
                  clearable: item.clearable,
                  disabled: isDisabled(item),
                  placeholder: item.placeholder
                }, null, 8, ["modelValue", "onUpdate:modelValue", "clearable", "disabled", "placeholder"]))
              : (item.type === 'select')
                ? (_openBlock(), _createBlock(_component_el_select, {
                    key: 1,
                    modelValue: _ctx.model[item.prop],
                    "onUpdate:modelValue": ($event: any) => ((_ctx.model[item.prop]) = $event),
                    class: "crud-form__control",
                    clearable: item.clearable,
                    disabled: isDisabled(item),
                    filterable: "",
                    placeholder: item.placeholder
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.options, (option) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: option.value,
                          label: option.label,
                          value: option.value
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 2
                  }, 1032, ["modelValue", "onUpdate:modelValue", "clearable", "disabled", "placeholder"]))
                : (item.type === 'date')
                  ? (_openBlock(), _createBlock(_component_el_date_picker, {
                      key: 2,
                      modelValue: _ctx.model[item.prop],
                      "onUpdate:modelValue": ($event: any) => ((_ctx.model[item.prop]) = $event),
                      class: "crud-form__control",
                      type: "date",
                      clearable: item.clearable,
                      disabled: isDisabled(item),
                      "value-format": item.valueFormat,
                      placeholder: item.placeholder
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "clearable", "disabled", "value-format", "placeholder"]))
                  : _renderSlot(_ctx.$slots, item.slot, {
                      key: 3,
                      item: item,
                      model: _ctx.model
                    })
          ]),
          _: 2
        }, 1032, ["label", "prop"]))
      }), 128))
    ]),
    _: 3
  }, 8, ["model", "rules", "label-width"]))
}
}

})